// For helpers outside React: SessionProvider shows these as auto-dismissing notices.
export const NOTICE_EVENT = 'woriva:notice';
export function showNotice(message: string): void {
  window.dispatchEvent(new CustomEvent(NOTICE_EVENT, { detail: message }));
}
